module.exports = __webpack_public_path__ + "img/cup-1.8968adb9.png";